import { patterns } from '../../../constants/patterns';

export const validateUrl = (value: string) =>
  !value || patterns.URL.test(value) || 'Invalid URL format: https://lifebase.solutions';
